/// <amd-module name="VSS/Redux/Modules/Telemetry/TelemetrySaga" />
import { effects, SagaIterator } from "redux-saga";
import { MetaTypes } from "redux/Actions/MetaTypes";
import { Action, ActionWithPayload, ActionsOfType } from "redux/Utils/ActionHelper";
import { IVssPageContext } from "VSS/Platform/Context";
import { IVssTelemetryService } from "VSS/Platform/Telemetry";
import { traceException } from "VSS/Platform/Trace";
import { TelemetryActionTypes, TelemetryAction } from "./TelemetryActions";
import { ITelemetryModuleArgs } from "./TelemetryContracts";
import { IVssPerformanceService, TelemetryEventData } from "VSS/Platform/Performance";

/**
 *  Monitors all actions for validation
 */
export function* monitorForTelemetry(args: ITelemetryModuleArgs): SagaIterator {
    yield effects.takeEvery((action: Action<any>) => action.meta && action.meta[MetaTypes.TELEMETRY_PROPS], publishTelemetry, args);
    yield effects.takeEvery((action: Action<any>) => action.meta && action.meta[MetaTypes.ERROR_TELEMETRY_PROPS], publishExceptionTelemetry, args);
    yield effects.takeEvery(TelemetryActionTypes.EndScenario, endScenario, args);
}

/**
 * Publishes CI telemetry
 */
export function* publishTelemetry(args: ITelemetryModuleArgs, action: Action<any>): SagaIterator {
    // get the page context
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const telemetryService: IVssTelemetryService = (yield effects.call([pageContext, pageContext.getService], "IVssTelemetryService")) as any;

    // publish the telemetry
    const telemetryProps: { [key: string]: any } = action.meta![MetaTypes.TELEMETRY_PROPS];
    yield effects.call([telemetryService, telemetryService.publishEvent], args.area, action.type, telemetryProps, args.serviceInstanceType);
}

export function* publishExceptionTelemetry(args: ITelemetryModuleArgs, action: ActionWithPayload<any, Error | string>): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    yield effects.call(traceException, pageContext, args.area, action.type, action.payload);
}

function* endScenario(args: ITelemetryModuleArgs, action: ActionsOfType<TelemetryAction, TelemetryActionTypes.EndScenario>): SagaIterator {
    const pageContext: IVssPageContext = (yield effects.getContext("pageContext")) as any;
    const performanceService: IVssPerformanceService = (yield effects.call([pageContext, pageContext.getService], "IVssPerformanceService")) as any;

    const additionalTelemetry = {
        serviceInstanceType : args.serviceInstanceType
    } as TelemetryEventData;

    yield effects.call([performanceService, performanceService.endScenario], args.area, action.payload.scenarioName, action.payload.isPageInteractive, undefined /*endTime*/, action.payload.properties, undefined /* split timings */, additionalTelemetry);
}